export const generateMicrosoftTeamsDeepLink = (email: string) =>
  `https://teams.microsoft.com/l/chat/0/0?users=${email}&topicName=&message=`;
